import { Component, OnInit, ViewChild, ElementRef, ChangeDetectorRef, ViewEncapsulation, ComponentFactoryResolver, ViewContainerRef, ComponentRef, OnDestroy, AfterViewInit, Input } from '@angular/core';
import { SensorCoreObject } from '../asp/SensorCoreObject';
import { MatTabGroup } from '@angular/material/tabs';
import * as aspSettings from '../asp/aspSettings';
import * as enums from '../common/enums';
import * as consts from '../common/consts';
import * as utils from '../common/utils';
import { IAro, AppInjector } from '../common/inject';
import { AroService } from './aro.service';
import { ZIndexMngr } from '@core_n/common/ZIndexMngr';
import { MatDialogRef } from '@angular/material/dialog';
import { AroAngularTrackComponent } from '../../../app/aro/aro-angularTrack.component';
import * as settings from '../common/settings';
import { Subject } from 'rxjs';
import { Animations } from '@core_n/Animations';
import { mainMapMngr } from '@core_n/asp/MapMngr';
import { AcousticVectorObject } from '@core_n/asp/AcousticVectorObject';

@Component({
  templateUrl: './aro-angularTrack-core.component.html',
  styleUrls: ['./aro.component.scss'],
  animations: [
    Animations.WindowOpenCloseFadeHeight
  ]
})
export class AroAngularTrackCoreComponent extends ZIndexMngr implements IAro, OnInit, OnDestroy, AfterViewInit {
  //Child Components
  @ViewChild('tabGroup') public tabGroup: MatTabGroup;
  @ViewChild('aroContainer', { read: ElementRef }) private aroContainer: ElementRef;
  @ViewChild('tab2Container', { read: ViewContainerRef }) protected tab2Container: ViewContainerRef;

  // @ViewChild('tab3Container', { read: ViewContainerRef }) protected tab3Container: ViewContainerRef;
  // @ViewChild('tab4Container', { read: ViewContainerRef }) protected tab4Container: ViewContainerRef;


  //Tab Management
  protected tab2ComponentRef: ComponentRef<any>;
  protected tab3ComponentRef: ComponentRef<any>;
  protected tab4ComponentRef: ComponentRef<any>;
  public tab1Label: string = "Overview";
  public tab2Label: string = 'Classiff';
  public tab3Label: string;
  public tab4Label: string;
  //labelSensorVector : string = 'Sensor-Vector';

  // subject that emits when the component is destroyed
  protected _onDestroy = new Subject<void>();

  //Form Management
  shown: boolean;
  angTrack: AcousticVectorObject;
  public sensor: SensorCoreObject = null;

  //AngTrack Data of ARO
  public angTrackId: any = '';
  public sensorId: number = 0;
  public sensorSymbol: string = "";
  public angle: string = "0";
  public maxfreqEnergy: number;
  public f0: string;
  public amplitude: string; // in DB between 20-120
  public sic: number;
  public sac: number;
  public time: string;
  public sensorSym: string;
  public snr: string;
  public cssColor: string;
  public cls: string;

  constructor(
    protected aroService: AroService,
    protected cdref: ChangeDetectorRef,
    elementRef: ElementRef,
    public dialogRef: MatDialogRef<AroAngularTrackComponent>) {
    super(elementRef);

    if (settings.userSettings.userPerm == enums.Permission.USER)
      this.ngOnDestroy();

    let self = this;
    setInterval(function () { self.refresh() }, consts.DIALOG_REFRESH_INTERVAL);
  }

  ngOnInit(): void {
    this.aroService.setAngTrackAro(this);
  }


  ngAfterViewInit() {
    setTimeout(() => {
      this.windowVisible.next(true);
    })
  }

  ngOnDestroy(): void {
    this.dialogClosed();
    this.dialogRef.close();
  }

  // Return factory to create tab 2-4 component
  protected getTabComponentFactory(tabIndex: number) {
    return null;
  }

  protected refresh(force: boolean = false): void {
    if ((this.shown || force) && this.angTrack != null) {
      //Try to set ARO to fixed height
      if (this.aroContainer) {
        let aroContainerElem = this.aroContainer.nativeElement as HTMLElement;
        if (aroContainerElem.offsetHeight > 0 && aroContainerElem.style.minHeight.length == 0)
          aroContainerElem.style.minHeight = `${aroContainerElem.offsetHeight}px`;
      }
    }
    this.angTrackId = this.angTrack.Data.ID;
    this.angle = this.angTrack.Data.Angle.toFixed(1);
    // this.maxfreqEnergy = +this.angTrack.Data.MaxFreqEnergy.toFixed(1);
    // this.f0 = this.angTrack.Data.f0.toFixed(1);
    this.amplitude = "50";
    this.sic;
    this.sac;
    this.snr = this.angTrack.Data.snr.toFixed(1);
    this.time = this.angTrack.Data.date.toLocaleTimeString('en-GB', { hour12:false });
    this.cls = this.angTrack.Data.cls;
    if (this.sensor) {
      this.sensorId = this.sensor.sensorID;
      this.sensorSymbol = this.sensor.sensorLetter;
    }
    this.cssColor = utils.newmiColorToString(this.angTrack.Data.lineColor);
  }

  public getShownId() {
    if (this.angTrack)
      return this.angTrack.Data.ID;
    else
      return null;
  }

  public updateLocation() {
    if (this.shown && this.angTrack && this.sensor)
      this.sensor.geometry;
  }

  public showAro(objectId): boolean {
    // let track = <TrackCoreObject>aspObjects.tracksPool.getObject(objectId);
    // if (!track)
    //   track = <TrackCoreObject>aspObjects.sensorTracksPool.getObject(objectId);
    // if (track) {
    //   this.track = track;
    //   this.shown = true;
    //   this.tabGroup.realignInkBar();
    //   this.refresh(true);
    // }
    // return track != null;


    return false; // delete me after.... yossi...
  }

  public hideAro() {
    this.angTrack = undefined;
    this.shown = false;
  }

  public isShown(): boolean {
    return this.shown;
  }

  onCenterBtnClick() {
    if (this.angTrack != null || this.sensor != null)
      return;
    mainMapMngr.setMapCenter(this.sensor.geometry);
  }

  colorOfIdentity(ident: enums.Hostility, handleDisabled: boolean = true) {
    let color = aspSettings.colorOfIdentity(ident);
    if (handleDisabled && ident == enums.Hostility.Pending)
      color = utils.newmiAlphaColor(color, 0.3);
    return utils.newmiColorToString(color);
  }

  // Style functions  
  getRotation(): string {
    return `translate(-50%,-50%) rotate(${this.angle}deg)`;
  }

}

var aroAngularTrackComponentFactory;
export function setAroAngularTrackComponentFactory(factory) {
  aroAngularTrackComponentFactory = factory;
}
export function getAroAngularTrackComponentFactory() {
  if (aroAngularTrackComponentFactory == undefined)
    aroAngularTrackComponentFactory = AppInjector.get(ComponentFactoryResolver).resolveComponentFactory(AroAngularTrackCoreComponent);
  return aroAngularTrackComponentFactory;
}


